import { planFeatureFeedbackInterceptor } from './core/services/subscriptions/plan-feature-feedback';
import { financialConfirmationInterceptor } from 'shared-ui';
import { environment } from '../environments/environment';
import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import {
  APEX_THEME_STORAGE_KEY,
  APEX_THEME_STORAGE_KEYS,
  ApexPrimeNgPreset,
  ApexThemeService,
} from 'shared-ui';

import { routes } from './app.routes';
import { isStaleChunkError, reloadForStaleChunk } from './core/stale-chunk/stale-chunk';
import { authExpiredInterceptor } from './core/interceptors/auth-expired.interceptor';
import { credentialsInterceptor } from './core/interceptors/credentials.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    { provide: APEX_THEME_STORAGE_KEY, useValue: APEX_THEME_STORAGE_KEYS.backoffice },
    provideAppInitializer(() => {
      inject(ApexThemeService);
    }),
    providePrimeNG({
      theme: {
        preset: ApexPrimeNgPreset,
        options: {
          darkModeSelector: "html[data-theme='dark']",
        },
      },
    }),
    provideRouter(
      routes,
      // The router catches lazy-load failures itself, so a stale tab after a deploy must be handled here: reload
      // straight to the page being opened instead of showing an error.
      withNavigationErrorHandler((error) => {
        if (typeof window !== 'undefined' && isStaleChunkError(error.error)) {
          reloadForStaleChunk(error.url);
        }
      }),
    ),
    provideClientHydration(withEventReplay()),
    provideHttpClient(
      withFetch(),
      withInterceptors([financialConfirmationInterceptor(environment.apiGatewayUrl), credentialsInterceptor, loadingInterceptor, authExpiredInterceptor, planFeatureFeedbackInterceptor]),
    ),
  ],
};
